import RtReconciliationSearchUnmatchedResponseBase from './base/RtReconciliationSearchUnmatchedResponseBase';

/**
 * @class RtReconciliationSearchUnmatchedResponse
 * @extends RtReconciliationSearchUnmatchedResponseBase
 */
class RtReconciliationSearchUnmatchedResponse extends RtReconciliationSearchUnmatchedResponseBase {

}

export default RtReconciliationSearchUnmatchedResponse;
